import { projectStatusConfig } from 'entities';

import { Column, Row } from 'components/Blocks';
import { ButtonGroup } from 'components/ButtonGroup';
import { KanbanBoxIcon, ListCollapseIcon, TableIcon } from 'components/Icons';

import { TaskTable } from './TaskTable';
import { KanbanView } from './Kanban';
import { TaskCards } from './TaskCards';

import { StartProject } from './StartProject';
import { ProjectStatus } from './Status';
import { ProjectTags } from './Tags';
import { ProjectDate } from './Date';
import { AssignProject } from './AssignProject';

import { useProjectProfile } from '../context';
import { useUrlStateV2 } from 'hooks';
import { cascadeEval } from 'utils/conditions';
import { appStorage } from 'utils/storage';

const viewComponents = {
  cards: TaskCards,
  table: TaskTable,
  kanban: KanbanView,
} as Record<string, typeof TaskCards>;

export function ProjectView() {
  const { project } = useProjectProfile();

  const [{ view }, updateUrl] = useUrlStateV2({
    view: {
      defaultValue: appStorage.session.get<string>('_pp__V') ?? 'cards',
      validate: (v) => Object.keys(viewComponents).includes(v),
      onValue: (tab) => appStorage.session.set('_pp__V', tab),
    },
  });

  const ViewComponent = viewComponents[view];

  const [isNotStarted, isNotAssigned] = [
    projectStatusConfig.notStated.code,
    projectStatusConfig.unassigned.code,
  ].map((s) => s === project.status);

  return (
    <Column gap="6" className="pb-5 pt-2">
      <Row className="small_tablet:flex-wrap" gap="2">
        <ProjectStatus />

        <ProjectDate />

        <ProjectTags />

        {!isNotStarted && !isNotAssigned && (
          <div className="ml-auto">
            <ButtonGroup
              value={view}
              onChange={(view) => updateUrl({ view })}
              options={[
                { value: 'cards', label: <ListCollapseIcon /> },
                { value: 'table', label: <TableIcon /> },
                { value: 'kanban', label: <KanbanBoxIcon /> },
              ]}
            />
          </div>
        )}
      </Row>

      {cascadeEval([
        { is: isNotStarted, then: <StartProject /> },
        { is: isNotAssigned, then: <AssignProject /> },
        { is: true, then: <ViewComponent /> },
      ])}
    </Column>
  );
}
